import { COLLECTION_FARO } from './constants/constants'

const collectionUtils = {
  isFaroCollection(collection) {
    return collection && collection.toUpperCase() === COLLECTION_FARO
  },
}

export default collectionUtils
